<template>
  <div id="student-main">
    <div v-if="mode === 'select'" @click="components.list = true" class="select">
      <h3 v-if="!value">请选择</h3>
      <h3 v-else>{{ selectedStudent.name }} {{ selectedStudent.name_eng }}</h3>
      <i class="anyteachicon anyteach-jiantouyou" />
    </div>
    <Modal
      v-if="components.list"
      ref="listModal"
      title="学生信息"
      :tapToDismiss="true"
      :showComplete="false"
      v-on:dismiss="$emit('dismiss'); components.list = false"
    >
      <List
        @edit="onEdit($event)"
        @create="onCreate"
        @select="$emit('input', $event)"
        :value="value"
        :mode="mode"
      />
    </Modal>
    <Modal
      v-if="components.edit"
      v-on:dismiss="components.edit = false"
      ref="editModal"
      :title="editable ? '编辑学生' : '新增学生'"
      :tapToDismiss="true"
      :showComplete="false"
    >
      <Edit :editable="editable" @complete="$refs.editModal.close('dismiss')" />
    </Modal>
  </div>
</template>

<script>
import List from "./List"
import Edit from "./Edit"

export default {
  props: {
    mode: {
      type: String,
      default: "list"
    },
    value: {
      type: Number,
      default: null
    }
  },
  components: {
    List,
    Edit
  },
  computed: {
    student() {
      return this.$store.state.user.student
    },
    selectedStudent() {
      if (!this.value) return null
      return this.student.find(item => item.id === this.value)
    }
  },
  data() {
    return {
      components: {
        list: false,
        edit: false
      },
      editable: null
    }
  },
  watch: {
    "components.edit": function (val) {
      if (!val) {
        this.editable = null
      }
    }
  },
  methods: {
    onEdit(item) {
      this.editable = item
      this.components.edit = true
    },
    onCreate() {
      this.components.edit = true
    }
  },
  created() {
    this.components.list = this.mode !== "select"
    this.$on("input", event => {
      if (this.mode === "select") this.$refs.listModal.close("dismiss")
    })
  }
}
</script>

<style lang="scss" scoped>
#student-main {
  .select {
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: all 0.1s;

    &:active {
      opacity: 0.6;
    }
    h3 {
      color: $blue;
      font-weight: 500;
    }
    i {
      font-size: 0.9rem;
      color: $blue;
    }
  }
}
</style>